export const partify = str => !str ? '' : (str.replace(/\//g, '').replace(/-/g, '').toLowerCase());

const alias = {
    'cds': ['cds-pp'],
    'cdu': ['pcp-pev'],
    'psd': ['ppd-psd'],
    'ps': ['ps.livre'],
    'be': ['b.e.']
};

let cores = {
    'ps': '#F37DB0',
    'psd': '#E27832',
    'be': '#D83932',
    'pcp': '#F13A34',
    'cds': '#0091DC',
    'pan': '#88C6C4',
    'pev': '#73BE43',
    'il': '#00AFE9',
    'ch': '#60479B',
    'l': '#B5D26E',
    'psn': '#202266',
    'prd': '#216B31',
    'mdp': '#AA1111',
    'asdi': '#2E3191',
    'ueds': '#9B1015',
    'udp': '#613484',
    'ppm': '#014A94',
    'adim': '#054A6E',
    'pi': '#CCCCCC',
    'pc': '#0000FF',
    'vp': '#4B0082',
    'ln': '#3796F0',
    'd21': '#FEAB19',
    'b': '#333399',
    'ppp': '#660087',
    'pl': '#FFC000',
    'rir': '#20B2AA',
    'a': '#00FFFF',
    'psd-ppm': '#FF9966',
    'cds-ppm': '#006DB8',
    'pdrjpp': '#043533',
    'jpp': '#0E766D',
    'agir': '#F2D514',
    'pcdc': '#000080',
    'pld': '#102142',
    'nc': '#FEAB19',
    'tda': '#8FBC8F',
    'paf': '#00549F',
    'mas': '#DC143C',
    'cconf': '#AA2288',
    'purp': '#259751',
    'ltda': '#98C75A',
    'aa': '#006DB8',
    'ppm-pda': '#025A8C',
    'pdr': '#060606',
    'ap': '#00549F',
    'ppm-pnd': '#446DB8',
    'cmud': '#AA2288',
    'feh': '#7F8322',
    'ph': '#FF7900',
    'ppv': '#000080',
    'ptp': '#CA0114',
    'mep': '#228B22',
    'mms': '#102142',
    'fp': '#00549F',
    'pnd': '#8891DC',
    'md': '#FFD700',
    'beudp': '#CA0114',
    'pnr': '#0D549C',
    'pg': '#1981CD',
    'ppr': '#0000FF',
    'ppmmpt': '#006B6C',
    'mhd': '#7C63BF',
    'pxxi': '#D21F1B',
    'mpt': '#008D45',
    'cdu': '#006699',
    'id': '#DD2222',
    'fer': '#831D1C',
    'udppsr': '#CA0114',
    'pcr': '#00A4CD',
    'fup': '#8B0000',
    'frs': '#FF3366',
    'pst': '#E30917',
    'fn': '#000000',
    'pda': '#036A84',
    'mirn': '#0000FF',
    'pous': '#E30917',
    'psr': '#8B0000',
    'mr': '#F25B6B',
    'apu': '#DC0B14',
    'fepu': '#FF0000',
    'gdup': '#CC1144',
    'pcpml': '#FF0000',
    'pup': '#CC4F99',
    'prt': '#B03060',
    'pdc': '#556B2F',
    'pt': '#FF5555',
    'mes': '#991155',
    'cdm': '#771951',
    'fsp': '#BB4422',
    'ocmlp': '#EE3300',
    'lci': '#831D1C',
    'anp': '#0000FF',
    'mrpp': '#FF0000',
    'ceud': '#DD2222',
    'cde': '#8B0000',
    'cem': '#00008B',
    'lsd': '#DC0019',
    'asp': '#CF1282',
    'ai': '#00CC00',
    'r': '#FFA500',
    'mud': '#FF0000',
    'munaf': '#FF0000',
    'un': '#0000FF',
    'ldr': '#FF7189',
    'oen': '#CC0033',
    'ulr': '#ECDB00',
    'pred': '#FF052F',
    'uie': '#FFD700',
    'prfn': '#B0CE90',
    'arp': '#014A94',
    'prn': '#4A452A',
    'preg': '#FF8C00',
    'prefr': '#960018',
    'uciv': '#BB3333',
    'prrn': '#AAA58A',
    'plr': '#2222AD',
    'prpop': '#FFD700',
    'cna': '#00008B',
    'pnrep': '#7A755A',
    'us': '#824298',
    'ccp': '#00BFFF',
    'ucat': '#000033',
    'ilus': '#000000',
    'prp': '#008000',
    'pd': '#FF7189',
    'pur': '#A52A2A',
    'pre': '#FFD700',
    'bl': '#00DDFF',
    'bc': '#2A52BE',
    'psop': '#CC4400',
    'posp': '#CC0044',
    'dp': '#FF0001',
    'pn': '#125890',
    'prl': '#254061',
    'pp': '#FF0000',
    'psp': '#CC0000',
    'pcons': '#808080',
    'o69': '#00DDFF',
    'gr': '#FF0000',
    'pa': '#D46A4C',
    'o68': '#FF0000',
    'fg': '#00DDFF',
    'o67': '#0010C0',
    'cec': '#7030A0',
    'cep': '#7030A0',
    'acep': '#0010C0',
    'prefm': '#953735',
    'cm': '#014A94',
    'phis': '#800000',
    'prgn': '#0070C0',
    'set': '#C00000',
    'xmrr': '#93CDDD',
    'pcart': '#376091',
    'pm': '#FF8C00',
    'ind': '#DDDDDD',
    'out': '#CCCCCC',
    'nul': '#999999',
    'bra': '#EEEEEE',
    'abs': '#333333',
    'ad': '#D66616',
    'a21': '#174150',
    'adn': '#1F4F85',
    'e': '#0D549C',
    'nd': '#012257',
    'ppdpsd.cdspp.ppm': '#D66616',
    'ppdpsd.cdspp': '#D66616'
};
/* 
export const assentos = [
    'B.E.',
    'PCP-PEV',
    'CDU',
    'L',
    'PS',
    'PS-L',//validar
    'PAN',
    'PPD/PSD',
    'PPD/PSD.CDS-PP',
    'PPD/PSD.CDS-PP.PPM',
    'CDS-PP',
    'PPM',
    'CH'
]; */

export const assentos = [
    'be', 'b.e.',
    'pcp-pev', 'pcppev',
    'cdu',
    'livres', 'livre', 'l',
    'ps.livre',
    'ps',
    'jpp',
    'pan',
    'restantes',
    'adn',
    'ad','psd', 'ppd-psd', 'ppdpsd', 'ppdpsd.cdspp', 'ppdpsd.cdspp.ppm',
    'cds', 'cds-pp', 'cdspp',
    'il',
    'a21',
    'nd',
    'chega', 'ch',
    'e'
];

export const acordos = [
    ['PS', 'B.E.'],
    ['PS', 'PCP-PEV'],
    ['PS', 'L'],
    ['PS', 'PAN'],
    ['PS', 'PPD/PSD'],
    ['PS', 'PCP-PEV', 'B.E.'],
    ['PS', 'PCP-PEV', 'L'],
    ['PS', 'B.E.', 'L'],
    ['PS', 'PAN', 'L'],
    ['PS', 'PCP-PEV', 'PAN'],
    ['PS', 'B.E.', 'PAN'],
    ['PS', 'PCP-PEV', 'B.E.', 'L'],
    ['PS', 'PCP-PEV', 'B.E.', 'L', 'PAN'],
    ['PPD/PSD', 'CDS-PP'],
    ['PPD/PSD', 'IL'],
    ['PPD/PSD', 'PAN'],
    ['PPD/PSD', 'CH'],
    ['PPD/PSD', 'CDS-PP', 'IL'],
    ['PPD/PSD', 'CDS-PP', 'IL', 'PAN'],
    ['PPD/PSD', 'CDS-PP', 'PAN'],
    ['PPD/PSD', 'IL', 'PAN'],
    ['PPD/PSD', 'CDS-PP', 'IL', 'CH']
];

export const cor = value => !value ? null : cores[partify(value)];

const set = (slug, key) => (!cores[slug] && (cores[slug] = cores[key]));

for (let key in alias) alias[key].forEach(slug => set(slug, key))

for (let key in cores)
    if (key.includes('.') || key.includes('-') || key.includes('/')) {
        const slug = key.replace(/[^\w\s]/gi, '');
        set(slug, key);
        set(partify(slug), key);
    }

export default {
    partify,
    assentos,
    acordos,
    cores,
    cor
}